(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("componentsbundle", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["componentsbundle"] = factory(require("React"), require("ReactDOM"));
	else
		root["componentsbundle"] = factory(root["React"], root["ReactDOM"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__1024__, __WEBPACK_EXTERNAL_MODULE__314__) => {
return 